import { expireSession, sessionSnapshot, isCurrentSession, InvalidSessionError } from "@/lib/session-expiration";

export function requestScope(url: string) {
  const path = new URL(url, "http://api.local").pathname;
  return path.startsWith("/api/platform/") ? "platform" : "church";
}

export function isPublicRequest(url: string, method = "get") {
  const path = new URL(url, "http://api.local").pathname;
  return /^\/api\/(?:platform\/)?auth\/(?:login|forgot-password|reset-password)\/?$/.test(path) ||
    path.startsWith("/api/invitations/") ||
    (path === "/api/platform/pilot-requests" && method.toLowerCase() === "post");
}

// Preserve domain response parsing; intercept invalid sessions before status is lost.
export async function authenticatedFetch(url: string, init: RequestInit = {}) {
  const scope = requestScope(url);
  const snapshot = sessionSnapshot(scope);
  const token = snapshot.token;
  if (!token) throw new InvalidSessionError();
  const headers = new Headers(init.headers);
  headers.set("Authorization", `Bearer ${token}`);
  const response = await fetch(url, { ...init, headers });
  if (!isCurrentSession(scope, snapshot)) throw new InvalidSessionError();
  if (response.status === 401) {
    expireSession(scope, token);
    throw new InvalidSessionError();
  }
  return response;
}
